import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";
import type { ProviderDto, ProviderFilter } from "@/features/ledger/api/dto";

/**
 * Providers paginés (`POST /Providers/all`, guide §4.2) — banques,
 * mobile money, billers, interne.
 */
export const useProviders = (
  params: ListRequest<ProviderFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.LEDGER_PROVIDERS_LIST(params),
    queryFn: () =>
      mutateData({
        url: ledgerEndpoints.providers.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<ProviderDto>>,
    enabled,
  });
